/**
 * Created by zhengyongbo on 2019/7/13.
 */
import Vue from 'vue'
import { currency } from './currency'
import dateFormat from './date-format'

Vue.filter('currency',currency);
Vue.filter('formatDate',dateFormat)
